// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__Tv+EA","icon":"Loading_icon__R6LUn"};